import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ENTER_KEYCODE, ENTER_KEY, SPACE_KEYCODE } from '../Utils/constant';
import styles from '@dtsl/css-stepper/dist/index.module.css';
import Check from '@dtsl/icons/dist/icons/react/Check';
function Step(props) {
  const {
    activeStep,
    stepData: {
      stepIndex,
      value,
      label,
      completed,
      stepHandler,
      disabled
    }
  } = props;
  const handleKeyDown = event => {
    if (event.key === ENTER_KEY || event.keyCode == ENTER_KEYCODE || event.keyCode === SPACE_KEYCODE) {
      if (disabled) {
        event.preventDefault();
      }
    }
  };
  const stepClasses = classNames({
    [styles['sib-stepper__item']]: true,
    [styles['sib-stepper__item--completed']]: completed && !disabled,
    [styles['sib-stepper__item--active']]: activeStep === stepIndex && !disabled && !completed,
    [styles['sib-stepper__item--disabled']]: disabled
  });
  const stepData = {
    ...((props === null || props === void 0 ? void 0 : props.stepData) || {})
  };
  return /*#__PURE__*/React.createElement("li", {
    className: stepClasses
  }, /*#__PURE__*/React.createElement("button", {
    className: styles['sib-stepper__step'],
    onClick: event => {
      event.preventDefault();
      stepHandler(stepData, event);
    },
    onKeyDown: event => handleKeyDown(event),
    "aria-current": activeStep === stepIndex ? 'step' : null,
    "aria-disabled": disabled ? true : false
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-stepper__content']
  }, typeof value === 'function' || completed ? /*#__PURE__*/React.createElement("span", {
    className: styles['sib-stepper__content--icon']
  }, completed ? /*#__PURE__*/React.createElement(Check, null) : value()) : /*#__PURE__*/React.createElement("span", {
    className: styles['sib-stepper__content--count']
  }, value)), /*#__PURE__*/React.createElement("span", {
    className: styles['sib-stepper__label']
  }, label)));
}
Step.defaultProps = {
  activeStep: 0,
  stepData: {
    stepIndex: 0,
    value: 0,
    label: '',
    completed: false,
    stepHandler: () => {},
    disabled: false
  }
};
Step.propTypes = {
  activeStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  stepData: PropTypes.object
};
export default Step;